import {GameScreen} from "../base/GameScreen";
import {GameView} from "../base/GameView";

export class GameScreenLayer extends GameView {
    override onResize() {
        for (let i = this.children.length - 1; i >= 0; i--) {
            let child = this.getChildAt(i);
            if(child instanceof GameScreen) {
                let screen = child as GameScreen;
                screen.onResize();
            }
        }
    }
}
